import { PopoverMenuItemProps } from '@wix/design-system';
import React from 'react';

export interface MoreActionsItem
  extends Omit<PopoverMenuItemProps, 'text' | 'prefixIcon' | 'onClick'> {
  /**
   * The text label of the action item. This property is required.
   * @external
   */
  text: string;
  /**
   * The functionality for when the user clicks the action item. This property is required.
   * @external
   */
  onClick: (params?: Record<string, any>) => unknown;
  /**
   * An icon to display before the text.
   * @external
   */
  prefixIcon?: React.ReactNode;
  /**
   * An icon displayed after the text.
   * @external
   */
  suffixIcon?: React.ReactNode;
  /**
   * The visual style of the action item. Options are 'dark' for the standard appearance or 'destructive' for a red text and red hover effect.
   * @external
   */
  skin?: 'dark' | 'destructive';
  /**
   * A data hook for testing purposes. This optional property can be used to identify the element in tests.
   * @external
   */
  dataHook?: string;
  /**
   * This property can be used to disable the action item both visually and functionally.
   * @external
   */
  disabled?: boolean;
  /**
   * A subtitle displayed under the text.
   * @external
   */
  subtitle?: string;
  /**
   * The name of the CTA for BI event.
   */
  biName?: string;
  /**
   * Additional info for CTAClick BI event.
   */
  biAdditionalInfo?: string;
}
